import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import SingleMetric from './SingleMetric';
import type { DateRange } from '../../../domain/reach';

const smallIconSize = 20;

const Title = styled.span`
  width: 100%;
  text-align: center;
  font-size: 22px;
  color: ${({ theme }) => theme.colors.primaryText};
  padding-top: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const MetricsWrapper = styled.div`
  display: flex;
  flex-flow: row;
`;

type Data = number | { current: number; compared: number };

type DateRangeMetricsProps = {
  dateRange: DateRange,
  averageQuarterHour: Data,
  smaller?: boolean,
  totalCumulative: Data,
  totalAverageReach: Data,

  t: any,
  theme: any,
};

const ReachDateRangeMetrics = (props: DateRangeMetricsProps) => {
  const {
    dateRange, totalCumulative, totalAverageReach, averageQuarterHour, smaller, t, theme,
  } = props;

  const styles = {};
  if (smaller) {
    styles.card = { backgroundColor: theme.colors.secondaryBackground };
    styles.title = { fontSize: 18 };
    styles.metricsText = { fontSize: 22 };
    styles.metrics = { padding: 8 };
  }

  const isOneWeekOrLess = dateRange.getWeekCount() <= 1;

  return (
    <React.Fragment>
      <Title style={styles.title}>
        {`${t('date.text', { value: dateRange.from })} - ${t('date.text', { value: dateRange.to })}`}
      </Title>
      <MetricsWrapper>
        <SingleMetric
          title={isOneWeekOrLess ? t('reach') : t('cumulativeReach')}
          value={totalCumulative}
          textStyle={styles.metricsText}
          wrapperStyle={styles.metrics}
          iconSize={smaller ? smallIconSize : undefined}
        />
        {!isOneWeekOrLess &&
          <SingleMetric
            title={t('totalReach')}
            value={totalAverageReach}
            textStyle={styles.metricsText}
            wrapperStyle={styles.metrics}
            iconSize={smaller ? smallIconSize : undefined}
          />
        }
        <SingleMetric
          title={t('averageQuarterHour')}
          value={averageQuarterHour}
          textStyle={styles.metricsText}
          wrapperStyle={styles.metrics}
          iconSize={smaller ? smallIconSize : undefined}
        />
      </MetricsWrapper>
    </React.Fragment>
  );
};

export default translate('metrics')(withTheme(ReachDateRangeMetrics));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/components/ReachDateRangeMetrics.js